import api from './http';

export const CustomersAPI = {
  list: (params = {}) => api.get('/customers', { params }).then((response) => response.data),
  create: (payload) => api.post('/customers', payload).then((response) => response.data),
  syncCec: (params = {}) => api.post('/customers/sync/cec', null, { params }).then((response) => response.data),
};
